import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TableContentGreenleafRouteSummaryReport } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { GreenleafRouteSummaryReportSchemaObject } from "../GreenleafRouteSummaryReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = "GREENLEAFROUTESUMMARYREPORT";

export function GreenleafRouteSummaryReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);

    const [greenleafRouteSummaryDetails, setGreenleafRouteSummaryDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(GreenleafRouteSummaryReportSchemaObject).options({ allowUnknown: true });
    const initialContentRownames = ["collectionPointName", "bagCountFi", "fieldGrossAmount", "fieldNetAmount",
        "factoryGrossAmount", "totalDeduction", "factoryNetAmount"];
    const [contentRowNames, setContentRowNames] = useState([]);
    // const initialColumnNames = ["Route Names", "No of Bags", "Gross /Kg", "Net /Kg", "Gross /Kg", "TD /kg", "Net /Kg", "G +/-"]
    const initialColumnNames = ["Route Names", "No of Bags", "Gross /Kg", "Net /Kg", "Gross /Kg", "TD /kg", "Net /Kg"]

    const [columnNames, setColumnNames] = useState([]);
    const initialCsvHeaders = [
        { label: "Route Name", value: "collectionPointName" },
        { label: "Bag Count", value: "bagCountFi" },
        { label: "Field Gross Amount /Kg", value: "fieldGrossAmount" },
        { label: "Field Net Amount /Kg", value: "fieldNetAmount" },
        { label: "Factory Gross Amount /Kg", value: "factoryGrossAmount" },
        { label: "Total Deducion /Kg", value: "totalDeduction" },
        { label: "Factory Net Amount /Kg", value: "factoryNetAmount" },
        // { label: "G +/-", value: "lex" }
    ]
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [fieldDeductions, setFieldDeductions] = useState([]);
    const [factoryDedutions, setFactoryDeductions] = useState([]);
    const [fullTotalRow, setFullTotalRow] = useState([]);
    const [csvTotalRow, setCsvTotalRow] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [greenleafRouteSummaryDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [greenleafRouteSummaryDetails.factoryID])

    function handleGroupChange(target) {
        validateInputs(target);

        setGreenleafRouteSummaryDetails({
            ...greenleafRouteSummaryDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setGreenleafRouteSummaryDetails({
            ...greenleafRouteSummaryDetails,
            factoryID: target.value,
            routeID: "0"
        });
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setGreenleafRouteSummaryDetails({
            ...greenleafRouteSummaryDetails,
            routeID: target.value,
        });
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setGreenleafRouteSummaryDetails({
            ...greenleafRouteSummaryDetails,
            fromDate: target.value,
        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setGreenleafRouteSummaryDetails({
            ...greenleafRouteSummaryDetails,
            toDate: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, GreenleafRouteSummaryReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'GREENLEAFROUTESUMMARYREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setGreenleafRouteSummaryDetails({
            ...greenleafRouteSummaryDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(greenleafRouteSummaryDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(greenleafRouteSummaryDetails.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {
        setReportData([]);
        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, greenleafRouteSummaryDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(greenleafRouteSummaryDetails);

        const result = await services.getLeafCollectionRouteSummaryReportData(greenleafRouteSummaryDetails);

        var factoryResultData = result.factoryData;
        var fieldResultData = result.feildData;

        var convertedFactoryData = removeFactoryDataDuplicates(factoryResultData);
        var convertedFieldData = removeFieldDataDuplicates(fieldResultData);

        var finalFactoryResult = factoryDataMergeByCollectionPoint(convertedFactoryData.finalresult);
        var finalFieldResult = fieldDataMergeByCollectionPoint(convertedFieldData.finalResult);

        var tableData = mergeFactoryAndFieldData(finalFactoryResult, finalFieldResult);

        var totRecord = {
            collectionPointName: "Total",
            bagCountFi: 0,
            fieldGrossAmount: 0,
            fieldNetAmount: 0,
            factoryGrossAmount: 0,
            factoryNetAmount: 0,
            lex: 0,
            totalDeduction: 0
        };

        tableData.forEach(value => {
            for (const property in value) {
                if (!isNaN(value[property])) {
                    totRecord[property] = (totRecord[property] === undefined ? 0 : parseFloat(totRecord[property]))
                        + parseFloat(value[property]);
                }
            }
        });

        setCsvTotalRow(totRecord)
        tableData.forEach(x => {

            for (const property in x) {
                if (property !== "collectionPointName" && property !== "bagCountFi") {
                    x[property] = parseFloat(x[property]).toFixed(2);
                }
            }
        });
        setDynamicHeaders(convertedFactoryData.factoryDeductions, convertedFieldData.fieldDeductions)

        if (tableData.length > 0) {
            setIsTableHide(false);
            setReportData(tableData);
            calculateTotal(tableData);
            createDataTable(tableData, ["#leafCollectionSummary", "#leafCollectionSummaryPdf"]);

        }
    }

    function setDynamicHeaders(facDeductions, fieDeductions) {
        var copyOfContentRowNames = initialContentRownames;
        var copyOfColumnNames = initialColumnNames;
        var copyOfCsvHeaders = initialCsvHeaders;

        var fieldDeductionsIds = [];
        var fieldDedutionNames = [];
        var factoryDeductionsIds = [];
        var factoryDedutionNames = [];
        var fieldsCsv = [];
        var factoryCsv = [];

        if (fieDeductions.length > 0) {
            fieDeductions.forEach(x => {
                fieldDeductionsIds.push(x.id);
                fieldDedutionNames.push(x.name.split(' ').map(x => x[0]).join(''));
                fieldsCsv.push({ label: x.name, value: x.id })
            });
        }
        if (facDeductions.length > 0) {
            facDeductions.forEach(x => {
                if (x.id != '0Fa') {
                    factoryDeductionsIds.push(x.id);
                    factoryDedutionNames.push(x.name.split(' ').map(x => x[0]).join(''));
                    factoryCsv.push({ label: x.name, value: x.id })
                }
            });
        }
        setFieldDeductions(fieldDeductionsIds)
        setFactoryDeductions(factoryDeductionsIds)
        copyOfContentRowNames.splice(3, 0, ...fieldDeductionsIds);
        copyOfContentRowNames.splice(5 + fieldDeductionsIds.length, 0, ...factoryDeductionsIds);

        copyOfColumnNames.splice(3, 0, ...fieldDedutionNames);
        copyOfColumnNames.splice(5 + fieldDedutionNames.length, 0, ...factoryDedutionNames);

        copyOfCsvHeaders.splice(3, 0, ...fieldsCsv);
        setColumnNames(copyOfColumnNames);
        setContentRowNames(copyOfContentRowNames);
        setCsvHeaders(copyOfCsvHeaders);

    }

    function mergeFactoryAndFieldData(factoryData, FieldData) {
        var merged = _.merge(_.keyBy(factoryData, 'collectionPointID'), _.keyBy(FieldData, 'collectionPointID'));
        var values = _.values(merged);

        values.forEach(x => {

            for (const property in x) {
                if (property !== "collectionPointName" && property !== "bagCountFi") {
                    x[property] = parseFloat(x[property]).toFixed(2);
                }
            }

            var facNet = x.factoryNetAmount === undefined ? 0 : x.factoryNetAmount;
            var fiNet = x.fieldNetAmount === undefined ? 0 : x.fieldNetAmount;
            var facGross = x.factoryGrossAmount === undefined ? 0 : x.factoryGrossAmount;
            var fiGross = x.fieldGrossAmount === undefined ? 0 : x.fieldGrossAmount;

            x.lex = parseFloat(facGross - fiGross).toFixed(2);
        });
        return values;
    }

    function removeFactoryDataDuplicates(data) {
        var result = [];
        var deductionArray = [];

        var complexResult;

        data.forEach(x => {
            if (result.length === 0) {
                result.push({
                    factoryGrossAmount: x.factoryGrossAmount,
                    factoryNetAmount: x.factoryNetAmount,
                    [x.deductionTypeID + "Fa"]: (x.factoryDeductionAmount),
                    factoryWeighDetailID: x.factoryWeighDetailID,
                    collectionPointID: x.collectionPointID,
                    collectionPointName: x.collectionPointName,
                    bagCount: x.bagCount,
                    totalDeduction: x.totalDeduction
                });
                deductionArray.push({ id: x.deductionTypeID + "Fa", name: x.deductionTypeName });
            } else {
                var selectedFactoryItem = result.find(y => y.collectionPointID === x.collectionPointID);

                if (!selectedFactoryItem) {
                    result.push({
                        factoryGrossAmount: x.factoryGrossAmount,
                        factoryNetAmount: x.factoryNetAmount,
                        [x.deductionTypeID + "Fa"]: (x.factoryDeductionAmount),
                        factoryWeighDetailID: x.factoryWeighDetailID,
                        collectionPointID: x.collectionPointID,
                        collectionPointName: x.collectionPointName,
                        bagCount: x.bagCount,
                        totalDeduction: x.totalDeduction
                    });
                    deductionArray.push({ id: x.deductionTypeID + "Fa", name: x.deductionTypeName });
                } else {
                    selectedFactoryItem[x.deductionTypeID + "Fa"] = (x.factoryDeductionAmount);
                    deductionArray.push({ id: x.deductionTypeID + "Fa", name: x.deductionTypeName });
                }
            }
        });
        var uniqDeductions = deductionArray.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)

        complexResult = {
            finalresult: result,
            factoryDeductions: uniqDeductions
        }

        return complexResult;
    }

    function factoryDataMergeByCollectionPoint(data) {
        var mergedFactoryDataResult = [];
        var grouped = _.groupBy(data, a => {
            return a.collectionPointID;
        });

        for (let [key, value] of Object.entries(grouped)) {
            var tempRecord = {};
            var bagCount = value[0].bagCount;
            value.forEach(x => {
                for (let [k, v] of Object.entries(x)) {
                    if (k !== "collectionPointID" && k !== "factoryWeighDetailID" && k !== "collectionPointName") {

                        if (!isNaN(k)) {
                            tempRecord[k + "Fa"] = (tempRecord[k + "Fa"] === undefined) ? (v)
                                : (tempRecord[k + "Fa"] + v);
                        } else {
                            tempRecord[k] = (tempRecord[k] === undefined) ? (v)
                                : (tempRecord[k] + v);
                        }
                    } else if (k === "collectionPointID") {
                        tempRecord.collectionPointID = v;
                    } else if (k === "collectionPointName") {
                        tempRecord.collectionPointName = v;
                    }
                }
            });

            tempRecord.bagCountFa = bagCount;
            mergedFactoryDataResult.push(tempRecord);
        }
        return mergedFactoryDataResult;
    }

    function removeFieldDataDuplicates(data) {

        var result = [];
        var deductionArray = [];

        var complexResult;

        data.forEach(x => {
            if (result.length === 0) {
                result.push({
                    fieldGrossAmount: x.fieldGrossAmount,
                    fieldNetAmount: x.fieldNetAmount,
                    [x.deductionTypeID + "Fi"]: (x.fieldDeductionAmount),
                    productCollectionDetailsID: x.productCollectionDetailsID,
                    collectionPointID: x.collectionPointID,
                    collectionPointName: x.collectionPointName,
                    bagCount: x.bagCount
                });
                deductionArray.push({ id: x.deductionTypeID + "Fi", name: x.deductionTypeName });
            } else {
                var selectedFactoryItem = result.find(y => y.collectionPointID === x.collectionPointID);

                if (!selectedFactoryItem) {
                    result.push({
                        fieldGrossAmount: x.fieldGrossAmount,
                        fieldNetAmount: x.fieldNetAmount,
                        [x.deductionTypeID + "Fi"]: (x.fieldDeductionAmount),
                        productCollectionDetailsID: x.productCollectionDetailsID,
                        collectionPointID: x.collectionPointID,
                        collectionPointName: x.collectionPointName,
                        bagCount: x.bagCount
                    });
                    deductionArray.push({ id: x.deductionTypeID + "Fi", name: x.deductionTypeName });
                } else {
                    selectedFactoryItem[x.deductionTypeID + "Fi"] = (x.fieldDeductionAmount);
                    deductionArray.push({ id: x.deductionTypeID + "Fi", name: x.deductionTypeName });
                }
            }
        });

        var uniqDeductions = deductionArray.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i)

        complexResult = {
            finalResult: result,
            fieldDeductions: uniqDeductions
        }

        return complexResult;
    }

    function fieldDataMergeByCollectionPoint(data) {
        var mergedFieldDataResult = [];

        var grouped = _.groupBy(data, a => {
            return a.collectionPointID;
        });

        for (let [key, value] of Object.entries(grouped)) {
            var tempRecord = {};
            var bagCount = value[0].bagCount;

            value.forEach(x => {
                for (let [k, v] of Object.entries(x)) {
                    if (k !== "collectionPointID" && k !== "productCollectionDetailsID" && k !== "collectionPointName") {

                        if (!isNaN(k)) {
                            tempRecord[k + "Fi"] = (tempRecord[k + "Fi"] === undefined) ? (v)
                                : (tempRecord[k + "Fi"] + v);
                        } else {
                            tempRecord[k] = (tempRecord[k] === undefined) ? (v)
                                : (tempRecord[k] + v);
                        }
                    } else if (k === "collectionPointID") {
                        tempRecord.collectionPointID = v;
                    } else if (k === "collectionPointName") {
                        tempRecord.collectionPointName = v;
                    }
                }
            });

            tempRecord.bagCountFi = bagCount;
            mergedFieldDataResult.push(tempRecord);
        }

        return mergedFieldDataResult;
    }

    function calculateTotal(data) {
        var total = [];
        data.forEach(x => {
            for (var property in x) {
                if (property !== "collectionPointName") {
                    total.push({ name: property, value: x[property] });
                }
            }
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, parseFloat(m.get(name) || 0) + parseFloat(value)), new Map
        ), ([name, value]) => ({ name, value }));

        setFullTotalRow(res);
        return res;
    }

    function createDataTable(contentResult, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                destroy: x === '#leafCollectionSummary' ? true : false,
                searching: x === '#leafCollectionSummary' ? false : true,
                paging: x === '#leafCollectionSummary' ? false : true,
                scrollX: false
            })
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'Greenleaf Route Summary',
            fileName: 'GreenleafRouteSummary',
            writeOptions: {}
        };

        var copyOfCsv = _.cloneDeep(reportData)
        copyOfCsv.push(csvTotalRow)

        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setGreenleafRouteSummaryDetails({
            ...greenleafRouteSummaryDetails,
            routeID: "0",
            fromDate: "",
            toDate: ""
        });
        setIsTableHide(true);
        setErrors("");
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Greenleaf Route Summary Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={greenleafRouteSummaryDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={greenleafRouteSummaryDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={greenleafRouteSummaryDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, greenleafRouteSummaryDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="table-responsive row-top-gap">
                                                <table id="leafCollectionSummary" className="display dataTable no-footer" style={{ width: "100%" }}>
                                                    <thead>
                                                        <tr>
                                                            <th colSpan="2"></th>
                                                            <th colSpan={2 + fieldDeductions.length} style={{ textAlign: "center" }}>Field Weight /Kg</th>
                                                            <th colSpan={3 + factoryDedutions.length} style={{ textAlign: "center" }}>Factory Weight /Kg</th>
                                                            {/* <th></th> */}
                                                        </tr>
                                                        <tr>
                                                            {columnNames.map((x, index) => {
                                                                return (
                                                                    <th key={index}>{x}</th>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <TableContentGreenleafRouteSummaryReport
                                                            data={reportData}
                                                            contentRowNames={contentRowNames}
                                                            hasEdit={false}
                                                        />
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            {contentRowNames.map((x, i) => {
                                                                if (x == "collectionPointName") {
                                                                    return (
                                                                        <th>Total</th>
                                                                    )
                                                                } else {
                                                                    var res = fullTotalRow.find(y => y.name === x.toString());
                                                                    if (res) {
                                                                        return (
                                                                            <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <th key={i} style={{ textAlign: "right" }}>{parseFloat(0).toFixed(2)}</th>
                                                                        );
                                                                    }
                                                                }
                                                            })}
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-4">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Greenleaf Route Summary Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"
                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} columnNames={columnNames} fieldDeductions={fieldDeductions}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} factoryDedutions={factoryDedutions} fullTotalRow={fullTotalRow} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
